import { Component, OnInit } from '@angular/core';
import { Faculty } from 'src/app/models/faculty.model';
import { FacultyService } from 'src/app/services/faculty/faculty.service';

@Component({
  selector: 'app-industrial-chemistry',
  templateUrl: './industrial-chemistry.component.html',
  styleUrls: ['./industrial-chemistry.component.scss']
})
export class IndustrialChemistryComponent implements OnInit {
  industry:Faculty[];
  constructor(private facultyService:FacultyService) { }

  ngOnInit(): void {
    this.industry=this.facultyService.getIndustrial();
  }

}
